var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    transform: "translate(1423 18623)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-1423 -18623)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958",
    transform: "translate(-1480 -18680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M68.5,68.5v20h20v-20Zm18,4h-2v-2h2Zm-6,0v-2h2v2Zm-2-2v2h-8v-2Zm-8,16v-12h16v12Z",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M150.493,222.129l-1.286-1.3a.99.99,0,0,0-1.408,0l-3.984,4.024a1.014,1.014,0,0,0,0,1.422h0a.99.99,0,0,0,1.408,0l3.278-3.31,1.286,1.3a.99.99,0,0,0,1.408,0l3.984-4.024a1.014,1.014,0,0,0,0-1.422h0a.99.99,0,0,0-1.408,0Z",
    transform: "translate(-71 -142.055)",
    fill: "#18beb3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractionIcon);
export default __webpack_public_path__ + "static/media/traction-icon.95e1dbc34646f9128f65c39c7cf8d9c9.svg";
export { ForwardRef as ReactComponent };